import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from '~/hooks';
import { adminSelectors } from '~/slices';
import { LoadingScreen } from '~/components';
import { webEndpoints } from '~/endpoints';

export const RequireAdmin = () => {
  const isAdmin = useSelector(adminSelectors.isAdmin);
  const loading = useSelector(adminSelectors.loading);

  if (loading) {
    return <LoadingScreen />;
  }

  if (!isAdmin) {
    return <Navigate to={webEndpoints.chatById.to('new')} replace />;
  }

  return <Outlet />;
};
